import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { environment } from "src/environments/environment";
import { SharedService } from "../services/shared.service";
import { IpsService } from "./ips.service";


@Injectable({
  providedIn: 'root'
})

  export class B2CUserAccountService {
  readonly ipsService:IpsService;
  private readonly config = environment.apiEndPoints;
  private readonly globalLogoutApiUrl =
  this.config.serverUrl + this.config.services.b2cuseraccount + this.config.endpoints.globalLogoutAPi;
  private readonly validateUserSessionUrl = this.config.serverUrl + this.config.services.b2cuseraccount + this.config.endpoints.validateUserSession;
  constructor(private readonly http: HttpClient, private readonly sharedService: SharedService, private readonly injector: Injector,) {
    this.ipsService = injector.get<IpsService>(IpsService);
  }
  globalLogout() {
    let request={
      userId: this.sharedService.userId
    }

    const header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'      
      }),
    };

    return this.http.post(
      `${this.globalLogoutApiUrl}`,
      request,
      header
    );
  }

  validateSignInSession(){
    if(localStorage.getItem("isB2Cupdate") == "true" && localStorage.getItem("B2CupdateType") == "email"){
      this.ipsService.notifyIndividualProfileUpdate({fanCode: Number(this.sharedService.fanCode), notificationType: 3}).subscribe()
    }
    
    let request={
      userId:this.sharedService.userId,      
      lastLogOnTime:this.sharedService.lastLogOnTime
    }

    const header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
    };

    return this.http.post(
      `${this.validateUserSessionUrl}`,
      request,
      header
    );
  }
}